export const ALL_SECTIONS = [
  { value: 'settings_system', label: 'General Settings' },
  { value: 'settings_agreements', label: 'Agreements' },
  { value: 'settings_email_credentials', label: 'Email Credentials' },
  { value: 'settings_bank_credentials', label: 'Bank Credentials' },
  { value: 'settings_crypto_credentials', label: 'Crypto Credentials' },
  { value: 'settings_trading_servers', label: 'Trading Servers' },
  { value: 'settings_trading_accounts', label: 'Trading Accounts' },
  { value: 'settings_trading_platform_alias', label: 'Trading Platform Alias' },
  { value: 'jurisdictions', label: 'Jurisdictions' },
  { value: 'kyc_steps', label: 'KYC Steps' },
  { value: 'kyc_fields', label: 'KYC Fields' },
  { value: 'kyc_field_dependencies', label: 'KYC Field Dependencies' },
  { value: 'email_templates', label: 'Email Templates' },
  { value: 'email_template_wraps', label: 'Email Template Wraps' },
];
